import { types, Actions } from './actions';
import { ReservationActions, ReservationBookingOnlineType } from './index';


const initialState: ReservationBookingOnlineType = {
  detailBooking: null,
  dataFormSubmit: null,
};

const reducer = (state = initialState, actions: Actions): ReservationBookingOnlineType => {
  switch (actions.type) {
    case types.SET_FINISH_BOOKING:
      return {
        ...state,
        detailBooking: actions.payload,
      };
    case types.SET_FORM_DATA_SUBMIT_BOOKING:
      return {
        ...state,
        dataFormSubmit: actions.payload,
      };
    default:
      return state;
  }
};

export default reducer;
